import script from "./generation.vue?vue&type=script&setup=true&lang=ts"
export * from "./generation.vue?vue&type=script&setup=true&lang=ts"

import "./generation.vue?vue&type=style&index=0&id=043e90a1&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-043e90a1"]])

export default __exports__